import { mapActions, mapState } from "vuex";

export default {
    beforeMount () {
        this.$store.dispatch('announcements/fetchAnnouncements')
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            currentUser: state => state.currentUser,
        }),
        ...mapState('announcements', {
            announcementsLoaded: state => state.announcementsLoaded,
            announcements: state => state.announcements,
        }),
        ...mapActions('announcements', {
            fetchAnnouncements: 'fetchAnnouncements'
        })
    },
    methods: {
        incrementAdClicks(adId) {
            this.$store.dispatch('announcements/incrementAdClicks', {
                'adId': adId,
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/overview/dashboard-announcements/dashboard-announcements.js